import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { actionTypes } from '../actions/types';
import { errorNames, getErrorMessage } from '../util/mappings/errorName';

type AppActions = import('../actions/types').AppActions;

export interface ErrorReducer {
    exception: RequestExceptionWithResponse | undefined;
    errorMessage: string;
}

export const initialState: ErrorReducer = {
    exception: undefined,
    errorMessage: '',
};

export const errorReducer = (state = initialState, action: AppActions = {} as AppActions): ErrorReducer => {
    switch (action.type) {
        case actionTypes.FETCH_USER_SESSION_FAILED:
        case actionTypes.FETCH_CASE_FAILED:
        case actionTypes.FETCH_STATUS_FAILED:
        case actionTypes.FETCH_CARDS_FAILED:
        case actionTypes.SEND_APPLICATION_FAILED: {
            const { errorName } = action.payload;
            const errorMessage = getErrorMessage(errorName);
            return {
                ...state,
                errorMessage,
            };
        }
        case actionTypes.SEND_ORDER_FAILED:
        case actionTypes.COMPLETE_ORDER_FAILED: {
            return {
                ...state,
                exception: action.payload,
                errorMessage: errorNames.internalError,
            };
        }

        case actionTypes.FETCH_USER_CONTEXT_FAILED: {
            const { errorName } = action.payload;
            const errorMessage = getErrorMessage(errorName);

            return {
                ...state,
                exception: action.payload,
                errorMessage,
            };
        }

        case actionTypes.SEND_FEEDBACK_FAILED:
        case actionTypes.FETCH_NAF_CACHE_FAILED: {
            const { errorName } = action.payload;
            const errorMessage = getErrorMessage(errorName, true);
            return {
                ...state,
                exception: action.payload,
                errorMessage,
            };
        }

        case actionTypes.KYC_ERROR: {
            return {
                ...state,
                errorMessage: errorNames.kyc_error,
            };
        }

        case actionTypes.FETCH_AGRI_MEMBER_FAILED: {
            const { errorName } = action.payload;
            const errorMessage = getErrorMessage(errorName, true);
            if ([errorNames.agriTokenParseFailed, errorNames.agriTokenValidFailed].includes(errorName)) {
                return {
                    ...state,
                };
            }
            return {
                ...state,
                exception: action.payload,
                errorMessage,
            };
        }

        case actionTypes.CREATE_SBL_CONSENT_FAILED: {
            const { errorName } = action.payload;
            const errorMessage = getErrorMessage(errorName, true);
            return {
                ...state,
                errorMessage,
            };
        }

        default:
            return state;
    }
};
